// Action Cable provides the framework to deal with WebSockets in Rails.
// You can generate new channels where WebSocket features live using the `bin/rails generate channel` command.

import { createConsumer } from "@rails/actioncable"

const consumer = createConsumer();
if (typeof window !== "undefined") {
  window.App = window.App || {};
  window.App.cable = consumer;
}

export default consumer
